export default __webpack_public_path__ + "static/media/expand-icon.a665c791.svg";